import type { FeatureTourStepConfig, FeatureTourStore } from './interfaces'

export const getters = {
  getCurrentStep: (state: FeatureTourStore): FeatureTourStepConfig | null => {
    if (!state.activeTour) {
      return null
    }

    return state.activeTour.stepsConfig.steps[state.currentStepIndex] ?? null
  },
  getStepCount: (state: FeatureTourStore): number => state.activeTour?.stepsConfig.steps.length ?? 0,
  hasSteps: (state: FeatureTourStore): boolean => (state.activeTour?.stepsConfig.steps.length ?? 0) > 0,
}
